import './components/pm-toast.ts';
import './components/pm-theme-toggle.ts';
import './components/pm-scroll-reveal.ts';
import './components/pm-counter-animation.ts';
import './components/pm-notification-bell.ts';
import './components/forms/pm-auth-modal.ts';
import './components/forms/pm-pairing-selector.ts';
import './components/forms/pm-tournament-form.ts';
import './components/forms/pm-padel-club-autocomplete.ts';
import './components/modals/pm-score-modal.ts';
import './components/modals/edit-match-pairs-modal.ts';
import './components/modals/assign-players-modal.ts';
import './components/matches/pm-match-card.ts';
import './components/controls/pm-undo-redo-toolbar.ts';
import './components/player-standings.ts';
import './components/simulations/pm-player-multi-selector.ts';
import './components/simulations/pm-player-groups-modal.ts';
import './components/simulations/pm-group-add-modal.ts';
import './components/simulations/pm-auto-add-players-modal.ts';
import './components/simulations/pm-smart-pairs-modal.ts';
import './src/components/tournament/pm-duplicate-tournament-modal.ts';
import './legacy/notifications';
import './legacy/messages';
import { autoMigrateLegacyElements } from './migration/legacy-to-lit';
import type { ThemeType, PmToast, PmThemeToggle, ToastOptions, ToastVariant } from './types';

const GLOBAL_TOAST_SELECTOR = 'pm-toast#pm-global-toast';

const getToastElement = (): PmToast | null => {
  return document.querySelector(GLOBAL_TOAST_SELECTOR) as PmToast | null;
};

const ensureToastElement = (): PmToast | null => {
  const toast = getToastElement();
  if (!toast) {
    console.warn(
      'pm-toast: elemento #pm-global-toast non trovato nel DOM. Aggiungi <pm-toast id="pm-global-toast"></pm-toast> vicino alla chiusura del body.'
    );
  }
  return toast;
};

const showToast = (options: ToastOptions): void => {
  const toast = ensureToastElement();
  if (!toast) {
    return;
  }

  toast.show(options);
};

const hideToast = (): void => {
  const toast = getToastElement();
  toast?.hide();
};

const bindDeclarativeTriggers = () => {
  const triggers = document.querySelectorAll('[data-pm-toast-message]');
  if (!triggers.length) {
    return;
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const element = trigger as HTMLElement;
      const options: ToastOptions = {
        message: element.dataset.pmToastMessage || ''
      };
      
      if (element.dataset.pmToastHeading) {
        options.heading = element.dataset.pmToastHeading;
      }
      
      if (element.dataset.pmToastVariant) {
        options.variant = element.dataset.pmToastVariant as ToastVariant;
      }
      
      if (element.dataset.pmToastAutohide) {
        options.autohide = Number.parseInt(element.dataset.pmToastAutohide, 10);
      }
      
      showToast(options);
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  bindDeclarativeTriggers();
});

// Theme management API
const getTheme = (): ThemeType => {
  const toggles = document.querySelectorAll('pm-theme-toggle') as NodeListOf<PmThemeToggle>;
  return toggles[0]?.theme || 'auto';
};

const setTheme = (theme: ThemeType): void => {
  const toggles = document.querySelectorAll('pm-theme-toggle') as NodeListOf<PmThemeToggle>;
  toggles.forEach(toggle => {
    toggle.theme = theme;
    // Trigghera manualmente gli eventi interni
    toggle._saveTheme(theme);
    toggle._applyTheme(theme);
  });
};

const cycleTheme = (): void => {
  const toggles = document.querySelectorAll('pm-theme-toggle') as NodeListOf<PmThemeToggle>;
  if (toggles[0]) {
    toggles[0]._cycleTheme();
  }
};

// Global API
window.PadelMatcher = window.PadelMatcher ?? {} as any;
window.PadelMatcher.ui = {
  ...(window.PadelMatcher.ui ?? {}),
  showToast,
  hideToast,
  theme: {
    get: getTheme,
    set: setTheme,
    cycle: cycleTheme
  }
};

const windowAny = window as any;
if (typeof windowAny.showToast !== 'function') {
  windowAny.showToast = showToast;
}

if (typeof windowAny.hideToast !== 'function') {
  windowAny.hideToast = hideToast;
}

// Auto-migrate legacy elements to Lit components
const debugMigration = window.location.search.includes('debug=migration');
autoMigrateLegacyElements(debugMigration);

// Debug component registry se richiesto
if (window.location.search.includes('debug=components')) {
  console.log('Debug componenti richiesto ma non disponibile');
}

window.dispatchEvent(
  new CustomEvent('padelmatcher:ui-ready', {
    detail: { ui: window.PadelMatcher.ui }
  })
);
